import styled from 'styled-components';

import {
  Input as SemanticInput,
  Form as SemanticForm,
} from 'semantic-ui-react';

export const Form = styled(SemanticForm)`
  width: 400px;
`;

export const FormField = styled(Form.Field)``;

export const Input = styled(SemanticInput)`
  &&& {
    margin: 0 10px 10px 10px;
  }
`;
